import { Router, ScreenBase } from "@frui.ts/screens";
import LocalizationService from "services/localizationService";
import AppRouter from "services/appRouter";
import NiaService, { SESSION_STORAGE_NIA_REQUEST_SOURCE_KEY } from "../../../services/NIA/niaService";

export const NIAModuleNavigationName = "nia";

@Router.registerRoute({ route: NIAModuleNavigationName, name: "nia" })
export default class NiaViewModel extends ScreenBase {
  constructor(public localizationService: LocalizationService, private niaService: NiaService, private router: AppRouter) {
    super();
    this.navigationName = NIAModuleNavigationName;
  }

  async navigate(subPath: string | undefined, params: any) {
    if (!params)
      this.router.navigate(sessionStorage.getItem(SESSION_STORAGE_NIA_REQUEST_SOURCE_KEY) || "exemption", undefined, undefined);

    const response = params.response;

    this.router.navigate(sessionStorage.getItem(SESSION_STORAGE_NIA_REQUEST_SOURCE_KEY) || "exemption", undefined, { response });
  }
}
